/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ContactDefs from './defs.defs.js'

const $nsid = 'app.bsky.contact.importContacts'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  token: /*#__PURE__*/ l.string(),
  contacts: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), {
    maxLength: 1000,
    minLength: 1,
  }),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  matchesAndContactIndexes: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ContactDefs.MatchAndContactIndex>(
      (() => ContactDefs.matchAndContactIndex) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Import contacts for securely matching with other users. This follows the protocol explained in https://docs.bsky.app/blog/contact-import-rfc. Requires authentication. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidDid',
  'InvalidContacts',
  'TooManyContacts',
  'InvalidToken',
  'InternalError',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
